<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/baseContent/photoAlbum' }"
          >相册列表
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">相册信息</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">配置相册信息</span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form
          :model="photoAlbum"
          label-width="120px"
          class="font-weight-bold w-75"
        >
          <el-form-item label="相片">
            <el-input
              v-model="photoAlbum.photoUrl"
              autocomplete="off"
              placeholder="轮播图URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg"
                ref="photoAlbumUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸65*65像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail text-muted"
                :src="photoAlbum.photoUrl"
                :preview-src-list="[photoAlbum.photoUrl]"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitBannerForm(photoAlbum)"
              >立即提交
            </el-button>
            <el-button @click="cancelSubmitForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import ImgUpload from "../../components/common/ImgUpload";
export default {
  name: "PhotoAlbumForm",
  data() {
    // noinspection JSUnresolvedVariable
    return {
      photoId: this.$route.params.photoId,
      photoAlbum: {
        photoUrl: ""
      }
    };
  },
  components: {
    ImgUpload
  },
  mounted() {
    if (this.photoId !== 0) {
      this.getPhotoAlbumById();
    }
  },
  methods: {
    getPhotoAlbumById() {
      this.axios
        .get("/photoAlbum/getPhotoAlbumById", {
          params: {
            photoId: this.photoId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.photoAlbum = resp.data.data;
          }
        });
    },
    uploadImg() {
      this.photoAlbum.photoUrl = this.$refs.photoAlbumUpload.url;
    },
    cancelSubmitForm() {
      this.$router.push({ name: "PhotoAlbum" }).catch();
    },
    submitBannerForm(photoAlbum) {
      this.axios
        .post("/photoAlbum/addOrPhotoAlbum", {
          photoId: photoAlbum.photoId,
          photoUrl: photoAlbum.photoUrl
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "PhotoAlbum" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
